import { TPlan, TPrice, TSubscription } from 'scenes/Subscription/types';
import { client } from './client';

const config = (): Promise<{ prices: TPrice[]; publishableKey: string }> => client.get('/subscriptions/config');

const createCustomer = (email: string): Promise<{ customer: { id: string } }> =>
  client.post('/subscriptions/create-customer', { email });

const createSubscription = (priceId: string): Promise<{ subscriptionId: string; clientSecret: string }> =>
  client.post('/subscriptions', { priceId });

const invoicePreview = () => client.get('/subscriptions/invoice-preview');

const cancelSubscription = (subscriptionId: string): Promise<{ subscription: TSubscription }> =>
  client.post('/subscriptions/cancel-subscription', { subscriptionId });

const updateSubscription = (subscriptionId: string, newPriceId: string) =>
  client.post('/subscriptions/update-subscription', { subscriptionId, newPriceId });

const subscriptions = (): Promise<{
  subscriptions: { data: TSubscription[] };
  expireDate: string;
  isActive: boolean | null;
  purchasePlatform: 'ios' | 'android';
  plan: TPlan;
  history: {
    action: string;
    amount: number;
    createdAt: string;
    type: string;
    updatedAt: string;
  }[];
}> => client.get('/subscriptions');

const customer = (): Promise<{ customer: { id: string } }> => client.get('/subscriptions/customer');

/**
 * Retrieves the client secret for non-recurring purchase.
 *
 * @param priceId - The unique identifier of the price for which the client secret is requested.
 */
const getClientSecret = (priceId: string): Promise<{ clientSecret: string }> =>
  client.post('/subscriptions/client-secret', { priceId });

export const subscription = {
  config,
  createCustomer,
  createSubscription,
  invoicePreview,
  cancelSubscription,
  updateSubscription,
  subscriptions,
  customer,
  getClientSecret,
};
